import time from './time';
import countryEditor from './countryEditor';
import editAssignFirstRevInvited from './editAssignFirstRevInvited';
import initialDecisionCompleted from './initialDecisionCompleted';
import numberOfReviewersInvitedPerManuscripts from './numberOfReviewersInvitedPerManuscripts';
import numberOfUniqueReviewersInvited from './numberOfUniqueReviewersInvited';
import assignmentInitialDecision from './assignmentInitialDecision';


export default [...time, ...countryEditor,...editAssignFirstRevInvited,...numberOfUniqueReviewersInvited,...numberOfReviewersInvitedPerManuscripts,...initialDecisionCompleted,...assignmentInitialDecision];